import React, { useState, useEffect } from 'react';
// import './Banner.css';
import './css.css'

const Banner = () => {
    const [bannerData, setBannerData] = useState({
        title: '서버 연결에 실패하였습니다',
        content: '서버 점검 중입니다.\n데이터 조회가 원활하지 않을 수 있습니다.\n빠른 시일 내에 정상화하겠습니다.\n불편을 드려 죄송합니다.',
        banner_image: '/maitenance.webp',
        admin_name: 'min5162',
        admin_email: 'rfkrdatasite@gmail.com',
        last_update: '',
        banner_status: 'maintenance',
        button_link: '',
        button_text: '배너 버튼',
        button_icon: '',
        button_target: '_blank',
        button_display: false
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchBannerData();
    }, []);

    const fetchBannerData = async () => {
        try {
            const response = await fetch('/api/banner/data');
            if (response.ok) {
                const data = await response.json();
                // 서버에서 받은 content의 \n 문자를 실제 줄바꿈으로 변환
                if (data.content) {
                    data.content = data.content.replace(/\\n/g, '\n');
                }
                setBannerData(data);
            }
        } catch (error) {
            console.error('배너 데이터 로드 실패:', error);
            // 기본값 설정 (DB 연결 오류)
            setBannerData({
                title: 'DB 연결 오류',
                content: '데이터베이스 연결에 실패했습니다.\n잠시 후 다시 시도해주세요.\n\n문제가 지속될 경우 관리자에게 문의해주세요.',
                banner_image: '/banner.webp',
                admin_name: 'min5162',
                admin_email: 'rfkrdatasite@gmail.com',
                last_update: '2025.08.16',
                banner_status: 'notice',
                button_link: '',
                button_text: '',
                button_icon: '',
                button_target: '_blank',
                button_display: false
            });
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="banner">
                <img src="/banner.webp" alt="Banner" className="banner-image" />
                <div className="banner-text">
                    <h1>로딩 중...</h1>
                </div>
            </div>
        );
    }

    const contentLines = bannerData.content ? bannerData.content.split('\n') : [];

    return (
        <div className={`banner banner-${bannerData.banner_status}`}>
            <img src={bannerData.banner_image || '/banner.webp'} alt="Banner" className="banner-image" />
            <div className="banner-text">
                <h1>{bannerData.title}</h1>
                {contentLines.map((line, index) => (
                    <p key={index}>{line}</p>
                ))}
                <p><strong>관리자 : {bannerData.admin_name}</strong></p>
                <p><strong>이메일 : {bannerData.admin_email}</strong></p>
                <p><strong>업데이트: {bannerData.last_update}</strong></p>
                
                {/* 배너 버튼 - button_display가 true이고 button_link가 있을 때만 표시 */}
                {bannerData.button_display && bannerData.button_link && (
                    <a 
                        href={bannerData.button_link} 
                        target={bannerData.button_target}
                        rel={bannerData.button_target === '_blank' ? 'noopener noreferrer' : undefined}
                        className="banner-button"
                    >
                        {bannerData.button_icon && (
                            <img 
                                src={`/${bannerData.button_icon}`} 
                                alt="버튼 아이콘" 
                                className="banner-button-icon"
                            />
                        )}
                        <span className="banner-button-text">{bannerData.button_text}</span>
                    </a>
                )}
            </div>
        </div>
    );
};

export default Banner;
